export interface DataGridHeader {
  value: string
  size: string
  hidden: boolean
}

export interface DataGridValue {
  header?: string
  value: string | number
  size: string
  align?: string
  color?: string
}

export enum DataGridRowStatus {
  Disabled,
  Enabled,
}

export interface DataGridRow {
  fields: DataGridValue[]
  status: DataGridRowStatus
}

export interface DataGrid {
  rows: {
    [rowName: string]: DataGridRow
  }
}

export const testCoeffData: DataGrid = {
  rows: {
    similarity: {
      fields: [
        { value: 1, size: 'xs1' },
        { value: 'Koeficient podobnosti', size: 'xs8', align: 'text-left' },
        { value: 0.98, size: 'xs2', color: 'primary' },
      ],
      status: DataGridRowStatus.Enabled,
    },
    difference: {
      fields: [
        { value: 2, size: 'xs1' },
        { value: 'Koeficient rozdílnosti', size: 'xs8', align: 'text-left' },
        { value: 0.95, size: 'xs2', color: 'primary' },
      ],
      status: DataGridRowStatus.Enabled,
    },
    distance: {
      fields: [
        { value: 3, size: 'xs1' },
        {
          value: 'Koeficient vzdálenosti od centra obce',
          size: 'xs8',
          align: 'text-left',
        },
        { value: 1.01, size: 'xs2', color: 'primary' },
      ],
      status: DataGridRowStatus.Enabled,
    },
  },
}

export const testValuationData: DataGrid = {
  rows: {
    firstSale: {
      fields: [
        {
          value: 'Valuace dle transakčních "prvoprodejů"',
          size: 'xs7',
          align: 'text-left',
        },
        { value: '6 086 000 Kč', size: 'xs2' },
        { value: '84 527 Kč/m²', size: 'xs2' },
      ],
      status: DataGridRowStatus.Enabled,
    },
    developers: {
      fields: [
        {
          value: 'Valuace dle prodaných bytů z ceníků developerů',
          size: 'xs7',
          align: 'text-left',
        },
        { value: '5 709 168 Kč', size: 'xs2' },
        { value: '79 294 Kč/m²', size: 'xs2' },
      ],
      status: DataGridRowStatus.Enabled,
    },
    preSale: {
      fields: [
        {
          value: 'Valuace dle transačních "přeprodejů"',
          size: 'xs7',
          align: 'text-left',
        },
        { value: '6 068 663 Kč', size: 'xs2' },
        { value: '84 297 Kč/m²', size: 'xs2' },
      ],
      status: DataGridRowStatus.Enabled,
    },
    final: {
      fields: [
        {
          value: 'Výsledná valuace nemovitosti',
          size: 'xs9',
          align: 'text-left',
        },
        { value: '5 954 610 Kč', size: 'xs2' },
        { value: '82 703 Kč/m²', size: 'xs2' },
      ],
      status: DataGridRowStatus.Enabled,
    },
  },
}

export const testValuationModData: DataGrid = {
  rows: {
    modified: {
      fields: [
        { value: 'Modifikovaná valuace', size: 'xs8', align: 'text-left' },
        { value: '5 709 168 Kč', size: 'xs2' },
        { value: '79 294 Kč/m²', size: 'xs2' },
      ],
      status: DataGridRowStatus.Enabled,
    },
    modifiedResult: {
      fields: [
        {
          value: 'Výsledek pro modifikaci',
          size: 'xs6',
          align: 'text-left',
        },
        { value: '9 transakcí', size: 'xs6', align: 'text-right' },
      ],
      status: DataGridRowStatus.Enabled,
    },
  },
}

export const testValuationPriceData: DataGrid = {
  rows: {
    price: {
      fields: [
        { value: 'Kupní cena nemovitosti', size: 'xs8', align: 'text-left' },
        { value: '6 000 000 Kč', size: 'xs2' },
        { value: '83 333 Kč/m²', size: 'xs2' },
      ],
      status: DataGridRowStatus.Enabled,
    },
  },
}

export const testDataGrid: DataGrid = {
  rows: {
    0: {
      fields: [
        { header: 'Katastrální území', value: 'Stodůlky', size: 'xs2' },
        { header: 'Číslo popisné', value: 2943, size: 'xs1' },
        { header: 'Číslo bytu', value: 29, size: 'xs1' },
        { header: 'Výměra', value: 73.2, size: 'xs1' },
        { header: 'Datum', value: '19. 9. 2018', size: 'xs2' },
        { header: 'Cena v Kč/m²', value: '67 741', size: 'xs1' },
        { header: 'Celková cena v Kč', value: '4 965 567', size: 'xs1' },
        { header: 'Garáž/stání', value: 1, size: 'xs1' },
        {
          header: 'Časově upravená cena v Kč',
          value: '4 965 567',
          size: 'xs1',
        },
      ],
      status: DataGridRowStatus.Enabled,
    },
    1: {
      fields: [
        { header: 'Katastrální území', value: 'Stodůlky', size: 'xs2' },
        { header: 'Číslo popisné', value: 2943, size: 'xs1' },
        { header: 'Číslo bytu', value: 29, size: 'xs1' },
        { header: 'Výměra', value: 73.2, size: 'xs1' },
        { header: 'Datum', value: '19. 9. 2018', size: 'xs2' },
        { header: 'Cena v Kč/m²', value: '67 741', size: 'xs1' },
        { header: 'Celková cena v Kč', value: '4 965 567', size: 'xs1' },
        { header: 'Garáž/stání', value: 1, size: 'xs1' },
        {
          header: 'Časově upravená cena v Kč',
          value: '4 965 567',
          size: 'xs1',
        },
      ],
      status: DataGridRowStatus.Enabled,
    },
    2: {
      fields: [
        { header: 'Katastrální území', value: 'Stodůlky', size: 'xs2' },
        { header: 'Číslo popisné', value: 2943, size: 'xs1' },
        { header: 'Číslo bytu', value: 29, size: 'xs1' },
        { header: 'Výměra', value: 73.2, size: 'xs1' },
        { header: 'Datum', value: '19. 9. 2018', size: 'xs2' },
        { header: 'Cena v Kč/m²', value: '67 741', size: 'xs1' },
        { header: 'Celková cena v Kč', value: '4 965 567', size: 'xs1' },
        { header: 'Garáž/stání', value: 1, size: 'xs1' },
        {
          header: 'Časově upravená cena v Kč',
          value: '4 965 567',
          size: 'xs1',
        },
      ],
      status: DataGridRowStatus.Enabled,
    },
    3: {
      fields: [
        { header: 'Katastrální území', value: 'Stodůlky', size: 'xs2' },
        { header: 'Číslo popisné', value: 2943, size: 'xs1' },
        { header: 'Číslo bytu', value: 29, size: 'xs1' },
        { header: 'Výměra', value: 73.2, size: 'xs1' },
        { header: 'Datum', value: '19. 9. 2018', size: 'xs2' },
        { header: 'Cena v Kč/m²', value: '67 741', size: 'xs1' },
        { header: 'Celková cena v Kč', value: '4 965 567', size: 'xs1' },
        { header: 'Garáž/stání', value: 1, size: 'xs1' },
        {
          header: 'Časově upravená cena v Kč',
          value: '4 965 567',
          size: 'xs1',
        },
      ],
      status: DataGridRowStatus.Enabled,
    },
    4: {
      fields: [
        { header: 'Katastrální území', value: 'Stodůlky', size: 'xs2' },
        { header: 'Číslo popisné', value: 2943, size: 'xs1' },
        { header: 'Číslo bytu', value: 29, size: 'xs1' },
        { header: 'Výměra', value: 73.2, size: 'xs1' },
        { header: 'Datum', value: '19. 9. 2018', size: 'xs2' },
        { header: 'Cena v Kč/m²', value: '67 741', size: 'xs1' },
        { header: 'Celková cena v Kč', value: '4 965 567', size: 'xs1' },
        { header: 'Garáž/stání', value: 1, size: 'xs1' },
        {
          header: 'Časově upravená cena v Kč',
          value: '4 965 567',
          size: 'xs1',
        },
      ],
      status: DataGridRowStatus.Enabled,
    },
    5: {
      fields: [
        { header: 'Katastrální území', value: 'Stodůlky 2', size: 'xs2' },
        { header: 'Číslo popisné', value: 2943, size: 'xs1' },
        { header: 'Číslo bytu', value: 29, size: 'xs1' },
        { header: 'Výměra', value: 73.2, size: 'xs1' },
        { header: 'Datum', value: '19. 9. 2018', size: 'xs2' },
        { header: 'Cena v Kč/m²', value: '67 741', size: 'xs1' },
        { header: 'Celková cena v Kč', value: '4 965 567', size: 'xs1' },
        { header: 'Garáž/stání', value: 1, size: 'xs1' },
        {
          header: 'Časově upravená cena v Kč',
          value: '4 965 567',
          size: 'xs1',
        },
      ],
      status: DataGridRowStatus.Enabled,
    },
    6: {
      fields: [
        { header: 'Katastrální území', value: 'Stodůlky 2', size: 'xs2' },
        { header: 'Číslo popisné', value: 2943, size: 'xs1' },
        { header: 'Číslo bytu', value: 29, size: 'xs1' },
        { header: 'Výměra', value: 73.2, size: 'xs1' },
        { header: 'Datum', value: '19. 9. 2018', size: 'xs2' },
        { header: 'Cena v Kč/m²', value: '67 741', size: 'xs1' },
        { header: 'Celková cena v Kč', value: '4 965 567', size: 'xs1' },
        { header: 'Garáž/stání', value: 1, size: 'xs1' },
        {
          header: 'Časově upravená cena v Kč',
          value: '4 965 567',
          size: 'xs1',
        },
      ],
      status: DataGridRowStatus.Enabled,
    },
    7: {
      fields: [
        { header: 'Katastrální území', value: 'Stodůlky 2', size: 'xs2' },
        { header: 'Číslo popisné', value: 2943, size: 'xs1' },
        { header: 'Číslo bytu', value: 29, size: 'xs1' },
        { header: 'Výměra', value: 73.2, size: 'xs1' },
        { header: 'Datum', value: '19. 9. 2018', size: 'xs2' },
        { header: 'Cena v Kč/m²', value: '67 741', size: 'xs1' },
        { header: 'Celková cena v Kč', value: '4 965 567', size: 'xs1' },
        { header: 'Garáž/stání', value: 1, size: 'xs1' },
        {
          header: 'Časově upravená cena v Kč',
          value: '4 965 567',
          size: 'xs1',
        },
      ],
      status: DataGridRowStatus.Enabled,
    },
    8: {
      fields: [
        { header: 'Katastrální území', value: 'Stodůlky 2', size: 'xs2' },
        { header: 'Číslo popisné', value: 2943, size: 'xs1' },
        { header: 'Číslo bytu', value: 29, size: 'xs1' },
        { header: 'Výměra', value: 73.2, size: 'xs1' },
        { header: 'Datum', value: '19. 9. 2018', size: 'xs2' },
        { header: 'Cena v Kč/m²', value: '67 741', size: 'xs1' },
        { header: 'Celková cena v Kč', value: '4 965 567', size: 'xs1' },
        { header: 'Garáž/stání', value: 1, size: 'xs1' },
        {
          header: 'Časově upravená cena v Kč',
          value: '4 965 567',
          size: 'xs1',
        },
      ],
      status: DataGridRowStatus.Enabled,
    },
    9: {
      fields: [
        { header: 'Katastrální území', value: 'Stodůlky 2', size: 'xs2' },
        { header: 'Číslo popisné', value: 2943, size: 'xs1' },
        { header: 'Číslo bytu', value: 29, size: 'xs1' },
        { header: 'Výměra', value: 73.2, size: 'xs1' },
        { header: 'Datum', value: '19. 9. 2018', size: 'xs2' },
        { header: 'Cena v Kč/m²', value: '67 741', size: 'xs1' },
        { header: 'Celková cena v Kč', value: '4 965 567', size: 'xs1' },
        { header: 'Garáž/stání', value: 1, size: 'xs1' },
        {
          header: 'Časově upravená cena v Kč',
          value: '4 965 567',
          size: 'xs1',
        },
      ],
      status: DataGridRowStatus.Enabled,
    },
  },
}
